module.exports = __webpack_public_path__ + "img/juyoufuli_logo.363cb1a1.png";